import { Component, Element, Event, Fragment, h, Method, Prop, State, Watch } from '@stencil/core';
import { v4 as uuidv4 } from 'uuid';
import { parseData, VERSION_FORM_COMPONENTS } from '../shared/utils';
/*

    Die c-form -Komponente ist ein Wrapper für c-form-controls, ähnlich dem nativen <form> - Tag
    Die values können als value-Attribute den Form-Controls übergeben werden,
    oder als eigenes value-Attribut in Form eines Objekts JSON string oder nativ.
    Beim "valuechange" - Event eines Form-Controls, wird intern der value aktualisiert.
    Beim Submit wird ein "formvaluechange" Event gefeuert.

*/
export class Form {
  constructor() {
    this.uuid = `form-${uuidv4()}`;
    this.version = VERSION_FORM_COMPONENTS;
    this.label = '';
    /*changeHandler(): void {
    }*/
    this.pristine = true;
  }
  handleValueUpdate(newValue) {
    let tmpValue = parseData(newValue);
    if (tmpValue && tmpValue !== this._value) {
      this._value = tmpValue;
    }
    this.formvaluechange.emit(this.value);
  }
  handleInitialValueUpdate(newValue) {
    let tmpValue = parseData(newValue || this.initialvalue);
    if (tmpValue && tmpValue !== this._initialvalue) {
      if (Array.isArray(tmpValue)) {
        this._initialvalue = [...tmpValue];
      }
      else {
        this._initialvalue = tmpValue;
      }
      this.value = this._initialvalue;
    }
  }
  // reset
  async reset() {
    var _a;
    this.pristine = true;
    this.value = (_a = this._initialvalue) !== null && _a !== void 0 ? _a : null;
  }
  /*handleFormControls() {
    // const formControls: NodeListOf<HTMLCFormControlElement> = this.host.querySelectorAll('c-form-control[name]');
    // formControls.forEach((control)=> {
    //     control.addEventListener('valuechange', (evt:CustomEvent)=> {
    //         const fieldname = control.getAttribute('name');
    //     })
    // })

  }*/
  componentDidLoad() {
    /*this.handleFormControls();

    const slot = this.host.shadowRoot.querySelector('slot') as HTMLSlotElement;

    slot.addEventListener('slotchange', () => {
      this.handleFormControls();
    });*/
  }
  render() {
    return (h(Fragment, null,
      h("slot", null)));
  }
  static get is() { return "c-form"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["c-form.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["c-form.css"]
  }; }
  static get properties() { return {
    "uuid": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "uuid",
      "reflect": false,
      "defaultValue": "`form-${uuidv4()}`"
    },
    "version": {
      "type": "string",
      "mutable": true,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "version",
      "reflect": true,
      "defaultValue": "VERSION_FORM_COMPONENTS"
    },
    "value": {
      "type": "any",
      "mutable": true,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "value",
      "reflect": true
    },
    "initialvalue": {
      "type": "any",
      "mutable": false,
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "initialvalue",
      "reflect": true
    },
    "label": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": ""
      },
      "attribute": "label",
      "reflect": false,
      "defaultValue": "''"
    }
  }; }
  static get states() { return {
    "_value": {},
    "_initialvalue": {},
    "pristine": {}
  }; }
  static get events() { return [{
      "method": "formvaluechange",
      "name": "formvaluechange",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }, {
      "method": "validate",
      "name": "validate",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": ""
      },
      "complexType": {
        "original": "any",
        "resolved": "any",
        "references": {}
      }
    }]; }
  static get methods() { return {
    "reset": {
      "complexType": {
        "signature": "() => Promise<void>",
        "parameters": [],
        "references": {
          "Promise": {
            "location": "global"
          }
        },
        "return": "Promise<void>"
      },
      "docs": {
        "text": "",
        "tags": []
      }
    }
  }; }
  static get elementRef() { return "host"; }
  static get watchers() { return [{
      "propName": "value",
      "methodName": "handleValueUpdate"
    }, {
      "propName": "initialvalue",
      "methodName": "handleInitialValueUpdate"
    }]; }
}
